/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { productCategorySchema } from "./productCategorySchema.ts";

export const categoriesListPathOrgUnitIdSchema = z.uuid();

export const categoriesListStatus200Schema = z.array(productCategorySchema);

export const categoriesListResponseSchema = categoriesListStatus200Schema;
